module.exports = __webpack_public_path__ + "79a06040df3607293221ce9aa0465c48.png";